<template>
  <div>
    <div v-for="(item, index) in value" :key="index">
      <asc-label :value="item"></asc-label>
    </div>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscReportMultipleSubheaders',

  components: {
    AscLabel,
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
  },
}
</script>
